export const login = {
  subtitle: {
    verifying: 'Verificando',
    verified: 'Verificado',
  },
  errors: {
    failedToSend: 'No se pudo enviar el codigo de verificacion. Intente de nuevo.',
    incorrectCode: {
      title: 'Código incorrecto',
      description: 'El código que ingresaste no es correcto. Por favor intenta de nuevo.',
    },
    codeExpired: {
      title: 'Código expirado',
      description: 'Tu código de verificación ha expirado. Por favor solicita uno nuevo.',
    },
    verificationFailed: {
      title: 'Verificación fallida',
      description: 'No pudimos verificar tu código. Por favor intenta de nuevo.',
    },
    failedToResend: 'No se pudo reenviar el codigo. Intente de nuevo.',
    invalidPhone: 'Numero de telefono invalido. Verifique e intente de nuevo.',
  },
};
